// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"67321987","455":"e8d86bbc","977":"e0883903"}[chunkId] + ".chunk.js";
};